//export const CorsAnywhere = "http://localhost:8080/";
//export const CorsAnywhere = "http://35.210.173.135/";
//export const CorsAnywhere = "https://cors-anywhere.herokuapp.com/";
export const CorsAnywhere = "https://cors.zerogravity.fi/proxy.php?csurl=";
//export const CorsAnywhere = "";
